import * as React from 'react'
import { Label, TextField } from 'react-rails-form-helpers'

interface IProps {
  promoCode?: string
  applyPromoCode: (e: React.MouseEvent) => void
  errors: string[]
}

interface IState {
  promoCode?: string
  showForm: boolean
}

export class PromoCodeForm extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props)

    const { promoCode } = props

    this.state = {
      promoCode,
      showForm: false,
    }
  }

  public handleApplyingPromoCode(e) {
    const { applyPromoCode } = this.props

    applyPromoCode(e)
    this.setState({
      showForm: false,
    })
  }

  public handlePromoCodeChange(promoCode) {
    this.setState({
      promoCode,
    })
  }

  public showForm() {
    this.setState({
      showForm: true,
    })
  }

  public link() {
    return (
      <a title="Apply a Promo Code" onClick={() => this.showForm()}>
        Do you have a promo code?
      </a>
    )
  }

  public applyingMessage() {
    return (
      <React.Fragment>
        <div className="applying-code"><em>Applying Promo Code</em></div>
      </React.Fragment>
    )
  }

  public appliedMessage() {
    const { promoCode: existingPromoCode } = this.props

    return (
      <React.Fragment>
        <div className="applied-code">
          Promo Code Applied: <strong>{existingPromoCode}</strong>
        </div>
        <a onClick={() => this.showForm()}>Use different code</a>

        <input type="hidden" name="cashier[promo_code]" value={existingPromoCode} />
      </React.Fragment>
    )
  }

  public errorMessage() {
    const { promoCode: newPromoCode } = this.state

    return (
      <React.Fragment>
        <div className="error">
          Promo Code <strong>{newPromoCode}</strong> is not valid for this purchase.
        </div>
        <a onClick={() => this.showForm()}>Use different code</a>

        <input type="hidden" name="cashier[promo_code]" value="" />
      </React.Fragment>
    )
  }

  public form() {
    const { promoCode: newPromoCode } = this.state

    return (
      <div className="grid-x">
        <div className="cell auto small-padded">
          <Label htmlFor="temp_promo_code">Promo Code</Label>
          <TextField
            name="promo_code"
            defaultValue=""
            onChange={(e) => this.handlePromoCodeChange(e.target.value)}
          />
        </div>

        <div className="cell shrink small-padded align-self-bottom">
          <button
            type="button"
            className="button primary pill"
            onClick={(e) => this.handleApplyingPromoCode(e)}
            disabled={!newPromoCode}
          >
            Apply Promo Code
          </button>
        </div>
      </div>
    )
  }

  public content() {
    const { promoCode: existingPromoCode, errors } = this.props
    const { promoCode: newPromoCode } = this.state
    const { showForm } = this.state

    if (showForm) {
      return this.form()
    } else if (errors && errors.length > 0) {
      return this.errorMessage()
    } else if (!!newPromoCode) {
      if (existingPromoCode === newPromoCode) {
        return this.appliedMessage()
      } else {
        return this.applyingMessage()
      }
    } else {
      return this.link()
    }
  }

  public render() {
    return (
      <div className="promo-code-form">
        {this.content()}
      </div>
    )
  }
}
